<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="organiza-txt historyList" v-if="historyType">
        <button class="btn btn-back" @click="historyHide">返回</button>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in historyList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in historyData" v-bind:key="(index+1)">
              <!-- <p :title="item.key">{{item.key}}</p> -->
              <p :title="item.credits">{{item.credits}}</p>
              <p :title="item.credits_time">{{item.credits_time}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="historyObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="historyPage">
            </el-pagination> 
          </div>
        </div>
      </div>
      <div class="MobelBox" v-else-if="CreditsType">
        <div class="write-txt">
          <p class="write-title">赠送额度<span>*</span></p>
          <div class="write-text">
            <input type="number" placeholder="请输入价格"  v-model="CreditsObj.credits">
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">积分有效期<span>*</span></p>
          <div class="write-text">
            <input type="number" class="num" v-model="CreditsObj.credits_time" @change="$forceUpdate()">
            <el-radio-group v-model="vip_date" style="display: inline-block;vertical-align: middle;">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="CreditSub">保存</button>
          <button class="btn btn-close" @click="CreditHide">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="searchBox clear">
            <div class="search-item">
              <p>用户ID：</p>
              <input type="text" placeholder="请输入要搜索的用户ID" v-model="obj.uid">
            </div>
            <div class="search-item">
              <p>用户昵称：</p>
              <input type="text" placeholder="请输入要搜索的用户昵称" v-model="obj.username">
            </div>
            <div class="search-item">
              <p>用户手机号：</p>
              <input type="text" placeholder="请输入要搜索的用户手机号" v-model="obj.mobile">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="exportUserSub">导出</button>
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.uid">{{item.uid}}</p>
              <p :title="item.username">{{item.username}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p :title="item.channel==1?'app':'百度'">{{item.channel==1?'app':'百度'}}</p>
              <p :title="item.is_member==0?'否':'是'">{{item.is_member==0?'否':'是'}}</p>
              <p :title="item.pay_time">{{item.pay_time}}</p>
              <p>
                <button title="赠送积分" class="btn btn-revise" @click="buildShow(item)">赠送积分</button>
                <button title="历史赠送" class="btn btn-remove" @click="historyShow(item)">历史赠送</button>
                <button title="演讲记录" class="btn btn-remove" @click="speechRecord(item)">演讲记录</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getUserList,exportUser,giveCredits,getGiveCreditsLog} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "vip",
  data() {
    return {
      navId:'7',
      childrenID:'7-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'用户ID'},
        {id:3,title:'用户昵称'},
        {id:4,title:'手机号'},
        {id:5,title:'注册时间'},
        {id:6,title:'注册渠道'},
        {id:7,title:'是否会员'},
        {id:8,title:'首次付费时间'},
        {id:9,title:'操作'},
      ],
      historyList:[
        // {id:1,title:'序号'},
        {id:2,title:'赠送积分额度'},
        {id:3,title:'赠送时间'},
        {id:4,title:'有效期'},
      ],
      dataList:[
      ],
      obj:{
        page:1,
        rows:10,
      },
      token:'',
      CreditsType:false,
      CreditsObj:{
        uid:'',
        credits:'',
        credits_time:''
      },
      vip_date:'d',
      historyObj:{
        uid:'',
        page:1,
        rows:10
      },
      historyData:[],
      historyType:false,
      historyPage:0,
      totalPage:0
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getList();
    console.log(this.$refs.navBox)
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if(this.historyType){
        this.historyShow(this.historyObj);
      } else {
        this.getList();
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
      };
      this.dataList = [];
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getUserList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async exportUserSub(){
      var that = this;
      var obj = {
        uid:this.obj.uid ? this.obj.uid : '',
        username:this.obj.username ? this.obj.username : '',
        mobile:this.obj.mobile ? this.obj.mobile : '',
      };
      if(obj.uid && obj.username && obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid + '&username=' + obj.username + '&mobile='+obj.mobile;
      } else if(obj.uid && obj.username){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid + '&username=' + obj.username;
      } else if(obj.uid && obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid + '&mobile=' + obj.mobile;
      } else if(obj.username && obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?username='+obj.username + '&mobile=' + obj.mobile;
      } else if(obj.username){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?username='+obj.username;
      } else if(obj.uid){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid;
      } else if(obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?mobile='+obj.mobile;
      } else {
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser';
      }
    },

    buildShow(e){
      this.CreditsType = true;
      this.CreditsObj = {
        uid:e.uid,
        credits:'',
        credits_time:''
      };
      this.vip_date = 'd';
    },

    CreditHide(){
      this.CreditsObj = {
        uid:'',
        credits:'',
        credits_time:''
      };
      this.CreditsType = false;
      this.vip_date = 'd';
    },

    async CreditSub(){
      var that = this;
      if(this.CreditsObj.credits == ''){
        that.$message('请填写赠送额度');
        return false;
      }
      if(this.CreditsObj.credits_time == ''){
        that.$message('请填写有效期');
        return false;
      }
      this.CreditsObj.credits_time = this.CreditsObj.credits_time + this.vip_date;
      console.log(this.CreditsObj);
      try {
        const response = await giveCredits(this.CreditsObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.CreditHide();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async historyShow(e){
      this.historyObj.uid = e.uid;
      var that = this;
      try {
        const response = await getGiveCreditsLog(this.historyObj,this.token);
        if(response.code == 200){
          that.historyData = response.data.list;
          that.historyPage = response.data.total_page;
          that.historyType = true;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    historyHide(){
      this.historyObj = {
        uid:'',
        page:1,
        rows:10
      };
      this.historyType = false;
      this.historyData = [];
    },

    speechRecord(e){
      // this.$router.push('/speechList?type=info');
      this.$router.push({ path: '/speechList', query: { type: 'info' } });
      // history.replaceState({ type: 'info' }, null, '/#/speechList?type=info');
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 9 );
  }

  .historyList .dataList .listItem p, 
  .historyList .organiza-list p{
    width: calc( 100% / 3 );
  }

  .btn-remove,
  .btn-revise{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #6E2FFF;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea {
    width: 80%;
    height: 65px;
    background-color: #f5f5f5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox input{
    width: 400px;
  }

  .MobelBox input.num{
    width: 100px;
    padding: 0 10px;
    margin-right: 20px;
    background-color: #f5f5f5;
    height: 50px;
    line-height: 50px;
    border-radius: 16px;
    display: inline-block;
    vertical-align: middle;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.searchBox>>>.search-item input{
  width: 200px;
}

.msgBox .contv{
  height: 80%;
}

.msgBox .btnBox{
  margin-top: 50px;
}

.msgBox>>>.el-radio__label{
  font-size: 15px;
}
.msgBox>>>.el-radio-group .el-radio{
  line-height: 30px;
}

.historyList .dataList{
  height: calc( 100% - 100px );
}
</style>



// WEBPACK FOOTER //
// src/user/info.vue